module.exports = __webpack_public_path__ + "static/grapecity-webinars.e3a1df1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/grapecity-webinars.png
// module id = 713
// module chunks = 23899280101116